(function () {
  var roots = new WeakMap();
  var retryTimer = null;
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function setActive(dots, index) {
    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle("is-active", dotIndex === index);
    });
  }

  function destroyRoot(root) {
    var state = roots.get(root);
    if (!state) return;

    state.triggers.forEach(function (trigger) {
      trigger.kill();
    });

    state.animations.forEach(function (animation) {
      animation.kill();
    });

    roots.delete(root);
  }

  function destroyAll(scope) {
    var rootsToDestroy = toArray((scope || document).querySelectorAll("[data-casebang-toy-story]"));

    if (scope && scope.matches && scope.matches("[data-casebang-toy-story]")) {
      rootsToDestroy.push(scope);
    }

    rootsToDestroy.forEach(destroyRoot);
  }

  function createAnimation(gsap, ScrollTrigger, root, panel, animations) {
    var copyItems = toArray(panel.querySelectorAll(".casebang-toy-kicker, .casebang-toy-heading, .casebang-toy-text, .casebang-toy-actions, .casebang-toy-feature"));
    var frame = panel.querySelector(".casebang-toy-showcase__frame");

    if (copyItems.length) {
      animations.push(gsap.fromTo(copyItems, {
        y: 34,
        opacity: 0.84
      }, {
        y: 0,
        opacity: 1,
        duration: 0.65,
        ease: "power3.out",
        stagger: 0.045,
        overwrite: true,
        immediateRender: false,
        scrollTrigger: {
          trigger: panel,
          start: "top 74%",
          end: "top 36%",
          toggleActions: "play none none reverse"
        }
      }));
    }

    if (frame) {
      animations.push(gsap.fromTo(frame, {
        scale: 1.045,
        opacity: 0.9
      }, {
        scale: 1,
        opacity: 1,
        duration: 0.72,
        ease: "power3.out",
        overwrite: true,
        immediateRender: false,
        scrollTrigger: {
          trigger: panel,
          start: "top 78%",
          end: "top 38%",
          toggleActions: "play none none reverse"
        }
      }));
    }
  }

  function initRoot(root) {
    if (!root || roots.has(root)) return;

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;

    if (!gsap || !ScrollTrigger || reduceMotion) {
      setActive(toArray(root.querySelectorAll(".casebang-toy-dot")), 0);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });

    var panels = toArray(root.querySelectorAll(".casebang-toy-panel"));
    var panelsWrap = root.querySelector(".casebang-toy-panels");
    var dots = toArray(root.querySelectorAll(".casebang-toy-dot"));
    var triggers = [];
    var animations = [];

    if (!panels.length || !panelsWrap) return;

    panels.forEach(function (panel, index) {
      panel.style.zIndex = String(index + 1);

      triggers.push(ScrollTrigger.create({
        trigger: panel,
        start: "top top",
        pin: true,
        pinSpacing: false,
        invalidateOnRefresh: true,
        anticipatePin: 1,
        onEnter: function () {
          setActive(dots, index);
        },
        onEnterBack: function () {
          setActive(dots, index);
        }
      }));

      createAnimation(gsap, ScrollTrigger, root, panel, animations);
    });

    if (panels.length > 1) {
      triggers.push(ScrollTrigger.create({
        trigger: panelsWrap,
        start: "top top",
        end: "bottom bottom",
        invalidateOnRefresh: true,
        snap: {
          snapTo: 1 / (panels.length - 1),
          duration: { min: 0.18, max: 0.42 },
          delay: 0.03,
          ease: "power2.out"
        }
      }));
    }

    roots.set(root, {
      triggers: triggers,
      animations: animations
    });

    setActive(dots, 0);
    window.addEventListener("load", function () {
      ScrollTrigger.refresh();
    }, { once: true });
    ScrollTrigger.refresh();
  }

  function init(scope) {
    var rootList = toArray((scope || document).querySelectorAll("[data-casebang-toy-story]"));

    if (scope && scope.matches && scope.matches("[data-casebang-toy-story]")) {
      rootList.push(scope);
    }

    if (!rootList.length) return;

    if ((!window.gsap || !window.ScrollTrigger) && !reduceMotion) {
      window.clearTimeout(retryTimer);
      retryTimer = window.setTimeout(function () {
        init(scope);
      }, 80);
      return;
    }

    rootList.forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    destroyAll(event.target);
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    destroyAll(event.target);
  });
})();
